import { atom, selector } from "recoil";
import { DateRangeType } from "types/dateRange";
import axios from "../utils/axios";
import { AssetType } from "types/common";
import { reducePriceValue } from "@api/assetLegacy";

export const valueState = atom({
  key: "indexGlobalValueState",
  default: 0,
});

// develop 은 DateRangeSubmitEvent 가 사실상 (any) => void 라 추론 타입으로도 통과했다.
// uschool 은 제대로 타입이 붙어 있어 atom 타입을 명시해야 한다.
export const indexGlobalChartDateState = atom<DateRangeType>({
  key: "indexGlobalChartDateState",
  default: {
    begin: null,
    end: null,
  },
});

export const selectedIndexTickerState = atom<AssetType|null>({
  key: "indexGlobalSelectedEtfTickerState",
  default: null,
});

export const analysisDataState = atom({
  key: "indexGlobalAnalysisDataState",
  default : {load:false}
})

export const simpleOperationListState = selector({
  key: "indexGlobalSimpleOperationListState",
  get: async ({ get }) => {
    const response = await axios.get(`bts/index/global/simple_operations`);
    return response.data.data;
  },
});

export const operationListState = selector({
  key: "indexGlobalOperationListState",
  get: async ({ get }) => {
    const response = await axios.get(`bts/index/global/operations`);
    return response.data.data;
  },
});

export const artificailIndexDataState = selector({
  key: "indexGlobalArtificailIndexDataState",
  get: async ({ get }) => {
    try {
      const selected = get(selectedIndexTickerState);
      if (selected === null) return;
      const { ticker } = selected;
      const dataParam = get(indexGlobalChartDateState);

      const response = await axios.get(`bts/index/global/artificial_prices/${ticker}`, {
        params: dataParam,
      });
      const responseObj = response.data.data;
      return reducePriceValue(responseObj);
    } catch (e) {}
  },
});
